/**
 * HumanizedAction (Story 34.5) — renders a `humanizeAction` sentence with its
 * `**bold**` markers turned into real <strong> emphasis (no markdown library).
 */

import { humanizeAction } from "@provenleap/audit";
import { parseBoldMarkdown } from "./activityVocab";
import type { AuditEventDto } from "../../hooks/useAuditEvents";

export function humanizeEvent(event: AuditEventDto): string {
  return humanizeAction(event.action, {
    actorEmail: event.actorEmailSnapshot,
    resourceName: event.resourceNameSnapshot,
    diff: { before: event.diffBefore ?? undefined, after: event.diffAfter ?? undefined },
    metadata: event.metadata,
  });
}

export function HumanizedAction({
  event,
  className,
}: {
  event: AuditEventDto;
  className?: string;
}) {
  const sentence = humanizeEvent(event);
  const segments = parseBoldMarkdown(sentence);
  return (
    <span className={className}>
      {segments.map((seg, i) =>
        seg.bold ? (
          <strong key={i} className="font-semibold text-foreground">
            {seg.text}
          </strong>
        ) : (
          <span key={i}>{seg.text}</span>
        )
      )}
    </span>
  );
}
